import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import StoreService from '../services/storeService'
import { setAutoJoinChat, setChatCooldown, setIsOneToMany } from './uiSlice'
import { setTermsAndConditions } from './callSlice'
import { validateBrowserLang } from '../utils/browserDetectUtils'

//* ASYNC THUNK ACTIONS
export const storeSetter = createAsyncThunk(
  'store/storeSetter',
  async ({ store, isMobile, browserLang, autoAcceptTermsAndConditions = false }, { dispatch }) => {
    dispatch(setStoreId(store.id))

    try {
      dispatch(
        setTermsAndConditions({
          countryCode: store.countryCode,
          customTermsAndConditions: store.storeConfigurations.features.termsAndConditions.active,
          autoAcceptTermsAndConditions,
        }),
      )
      dispatch(setAutoJoinChat(store.autoJoinChat))
      dispatch(setChatCooldown(store.storeConfigurations.features.chat.cooldown))
      dispatch(setIsOneToMany({ isOneToMany: store.isOneToManySale, isMobile }))
      const lang = validateBrowserLang(browserLang) ?? store.lang
      return { ...store, lang }
    } catch (error) {
      console.error(error)
      return null
    }
  },
)

export const getStoreIsOpen = createAsyncThunk('store/getStoreIsOpen', async (storeId) => {
  const response = await StoreService.getStoreIsOpen(storeId)

  return response.data
})

export const callStore = createAsyncThunk('store/callStore', async (storeId) => {
  const response = await StoreService.callStore(storeId)
  return response
})

export const setFinishEventCountdown = createAsyncThunk(
  'store/setFinishEventCountdown',
  async (data) => {
    const response = await StoreService.setFinishEventCountdown(data)
    return response
  },
)

export const setStartEventCountdown = createAsyncThunk(
  'store/setStartEventCountdown',
  async (data) => {
    const response = await StoreService.setStartEventCountdown(data)
    return response
  },
)

export const storeSlice = createSlice({
  name: 'store',
  initialState: {
    id: null,
    current: null,
    currentVideoTrack: null,
    error: '',
    status: '',
  },
  reducers: {
    setSellerVideoTrack: (state, action) => {
      state.sellerVideoTrack = action.payload.sellerVideoTrack
    },
    setStoreId: (state, action) => {
      state.id = action.payload
    },
    setRemainingSeconds: (state, action) => {
      state.current.remainingSeconds = action.payload
    },
    setVideoCommerceStore: (state, action) => {
      state.videoCommerceStore = action.payload
    },
  },
  extraReducers: {
    [getStoreIsOpen.fulfilled]: (state, action) => {
      state.current = action.payload
    },
    [getStoreIsOpen.rejected]: (state, action) => {
      state.error = action.error.message
    },
    [storeSetter.fulfilled]: (state, action) => {
      state.current = action.payload
    },
    [storeSetter.rejected]: (state, action) => {
      state.error = action.error.message
    },
    [callStore.fulfilled]: (state, action) => {
      state.status = action.payload.state
    },
    [callStore.rejected]: (state, action) => {
      state.error = action.error.message
    },
  },
})

//* ACTIONS

export const { setSellerVideoTrack, setStoreId, setRemainingSeconds, setVideoCommerceStore } =
  storeSlice.actions

//* SELECTORS
export const selectCurrentStore = (state) => state.store.current
export const selectStoreId = (state) => state.store.current.id
export const selectSellerVideoTrack = (state) => state.store.sellerVideoTrack
export const selectChatVersion = (state) =>
  state.store.current?.storeConfigurations?.features?.chat?.type

//* REDUCER
export default storeSlice.reducer
